<template>
  <div class="forget" id="forget">
    <div class="logo-top">
      <div class="img">
        <router-link to="/">
          <img src="../assets/img/xinli_logo.png">
          <img src="../assets/img/logo.jpg">
        </router-link>
      </div>
      <div class="name">喜安心理线上施测系统</div>
    </div>
    <div class="forget-shade">
      <div class="font">
        <img src="../assets/img/img_notebook.png">
      </div>
      <div class="forget-box">
        <form action="/api/forget" method="post">
          <h1>密码重置</h1>
          <label>登录账号</label>
          <div class="input-box">
            <span class="icon-account">
              <svg t="1735002044925" style="width: 28px !important;;height: 40px !important;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5137" width="48" height="48"><path d="M909 921.7c-0.8-17.1-2.5-34.1-5.4-51.2-5.8-34.5-16.2-67.4-31.2-99-26.2-55.3-62.8-101.9-110.7-139.8-37.5-29.9-79.1-52.4-124.8-67.4-2.9-0.8-5.8-2.1-8.7-2.9 0.8-0.4 1.3-0.8 1.7-0.8 20.4-10 39.5-22.5 56.6-37.5 25-21.6 45.4-47.4 60.7-77 21.6-41.6 31.2-85.7 29.1-132.7-0.8-14.1-2.5-28.3-5.4-42-10.4-47.9-32.9-89.5-66.6-125.2-14.6-15.4-31.2-29.1-49.1-40.4-38.7-24.5-80.7-38.3-126.1-41.2-12.5-0.8-25.4-0.8-37.9 0.4-14.1 1.3-28.3 3.3-42 6.7-45.8 11.2-86.1 32.9-120.7 65.3-22.5 21.2-40.8 45.3-54.5 72.8-20.4 40.8-29.5 83.6-27.5 129 0.4 12.5 2.1 25 4.6 37 9.6 48.3 30.8 90.3 64.1 126.5 22 24.1 48.3 43.7 77.4 58.2 0.4 0.4 1.3 0.4 1.7 1.3-9.2 2.9-18.7 5.8-27.4 9.6-9.2 3.8-18.3 7.5-27 11.7-50.4 24.1-93.7 57-130.3 99-19.6 22.5-36.2 47-50.3 73.2-17.5 32.5-29.5 67-37 103.2-3.3 15.8-5.8 32-6.7 47.9-0.4 6.3-0.8 12.5-1.3 18.3 0 5.8-0.8 11.2 0.4 17.1 2.1 10.8 12.5 18.3 23.7 17.5 10.8-0.8 19.6-10 20-20.8 0.4-7.1 0.4-14.6 0.8-21.6 0.4-10.8 1.7-21.2 3.3-32 3.3-21.2 8.3-42.5 15.8-62.8 16.6-47 42-88.2 76.6-124 22.9-23.7 48.3-44.1 77-60.7 24.5-14.6 50.4-25.8 77.4-33.7 19.1-5.8 38.7-10 58.7-12.5 12.9-1.7 25.8-2.5 38.7-2.5 0.8 0 1.7-0.4 2.5 0h7.5c0.4 0 1.3 0 1.7 0.4 4.6 0 9.2 0 13.7 0.4 15 0.8 30.4 2.5 45.4 5.4 31.2 5.8 61.2 15.4 89.5 29.1 46.6 22.5 86.5 53.7 119.8 93.6 28.7 35 49.9 73.7 63.7 116.9 7.1 22.5 11.7 45.4 14.2 69.1 1.3 11.7 1.7 23.3 1.7 35 0.4 12.1 10 21.6 22.5 21.6 12.1 0 21.6-10 21.6-21.6-1.5-6.9-1.5-11.9-1.5-16.9zM550.8 540.1c-12.5 2.1-25 3.3-37.5 3.8h-10.4c-8.7 0.4-16.2-1.3-24.5-2.5-23.3-3.3-45.4-10.4-66.6-21.2-9.2-4.6-17.9-9.6-26.2-15.4-19.1-13.3-36.2-29.1-50.3-47.9-15.4-20-26.6-42-34.1-66.2-5.8-18.3-8.8-36.6-10-55.8-0.4-12.5 0-25.4 1.7-37.9 3.8-26.6 11.7-51.6 25-74.9 12.9-23.3 29.5-44.1 50.3-61.2 17.9-15.4 37.9-27.5 59.9-36.2 23.3-9.6 47.4-14.6 72.4-15.8 9.6-0.4 19.1-0.4 28.7 0.4 10.4 0.8 20.8 2.5 30.8 4.6 22.5 5 43.7 13.3 63.7 25 17.9 10.4 33.7 22.9 48.3 38.3 8.3 9.2 16.2 18.3 23.3 28.7 12.1 17.9 21.6 37.5 27.9 58.2 5.4 17.9 8.3 35.8 9.2 54.5 0.4 8.7 0 17.9-0.8 26.6-0.8 11.2-2.9 22.5-5.4 33.3-5 19.6-12.1 38.3-22.5 55.8-12.9 22-28.7 41.6-48.3 57.8-14.6 12.5-30.8 22.9-48.3 31.2-18.5 7.3-37.2 13.5-56.3 16.8z" p-id="5138" fill="#cccccc"></path></svg>
            </span>
            <input type="account" placeholder="请输入您的登录账号" autocomplete="off"
                   v-model="formData.account" >
          </div>
          <label>手机号码</label>
          <div class="input-box">
            <span class="icon-phone"></span>
            <input type="tel" placeholder="请输入手机号" autocomplete="off"
                   v-model="formData.phone" >
          </div>
          <label>手机验证码</label>
          <div class="input-box">
            <span class="icon-code"></span>
            <input class="code-input" type="text" placeholder="请输入验证码" autocomplete="off"
                   v-model="formData.phone_code">
            <code-btn class="code-btn" :account="formData.account" :type="1" :mobile="formData.phone" :url="codeUrl"></code-btn>
          </div>
          <label>新密码</label>
          <div class="input-box">
            <span class="icon-lock"></span>
            <input type="password" placeholder="请输入新密码" autocomplete="off"
                   v-model="formData.password">
          </div>
          <label>确认密码</label>
          <div class="input-box">
            <span class="icon-lock"></span>
            <input type="password" placeholder="请再次输入新密码" autocomplete="off"
                   v-model="formData.re_password">
          </div>
          <div class="button-box">
            <button type="button" @click="regSubmit">立即重置</button>
          </div>
          <div class="to-home"><router-link to="/login">已有账号？去登录&gt;&gt;</router-link></div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import CodeBtn from '@/components/CodeBtn'

export default {
  name: '',
  data () {
    return {
      formData: {
        account:'',
        phone: '',
        phone_code: '',
        password: '',
        re_password: ''
      },
      codeUrl: 'login/sendForgetMsg'
    }
  },
  mounted: function () {
    var div = document.getElementById('forget')
    var h = document.documentElement.clientHeight || document.body.clientHeight
    div.style.minHeight = h + 'px'
  },
  components: {
    CodeBtn
  },
  methods: {
    regSubmit: function () {
      if (!this.formData.account) {
        this.$layer.msg('请输入登录账号！')
        return true
      }
      if (!this.formData.phone) {
        this.$layer.msg('请输入手机号码！')
        return true
      }
      // let phone = /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      let phone = /^1[3456789]\d{9}$/
      if (!phone.test(this.formData.phone)) {
        this.$layer.msg('您输入的手机号码不正确，请重新输入！')
        return true
      }
      if (!this.formData.phone_code) {
        this.$layer.msg('请输入验证码！')
        return true
      }
      if (!this.formData.password) {
        this.$layer.msg('请输入密码！')
        return true
      }
      let psw = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/
      if (!psw.test(this.formData.password)) {
        this.$layer.msg('密码格式不正确，由6-21字母和数字组成，不能为纯数字和纯字母！')
        return true
      }
      if (this.formData.password !== this.formData.re_password) {
        this.$layer.msg('两次密码输入不一致，请重新输入！')
        return true
      }
      let params = this.formData
      this.$post('login/resetPassword', params).then(res => {
        this.$layer.msg(res.msg)
        if (res.code === 20000) {
          setTimeout(() => {
            this.$router.push('/login')
          }, 500)
        }
      }).catch(response => {
        this.$layer.msg('网络异常，请稍后重试！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../assets/css/page/forget');
</style>
